<div *ngIf="donorInfo" class="grid mx-3">
  <div class="col-12 sm:col-6">
    <p><b>First Name:</b> {{ donorInfo.firstName }}</p>
    <p><b>Last Name:</b> {{ donorInfo.lastName }}</p>
  </div>
  <div class="col-12 sm:col-6">
    <p><b>Prefix:</b> {{ donorInfo.prefix || 'N/A' }}</p>
    <p><b>Suffix:</b> {{ donorInfo.suffix || 'N/A' }}</p>
    <p><b>Organization:</b> {{ donorInfo.organization || 'N/A' }}</p>
  </div>
</div>
